import { FontFamily } from '@euler/components/typography/fonts';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import React, { useMemo } from 'react';
import { StyleSheet, Text } from 'react-native';

export function useInlineFormatter() {
  const { rpx } = useResponsiveContext();
  const s = useMemo(
    () =>
      StyleSheet.create({
        bold: {
          fontFamily: FontFamily.NotoSans.Bold,
        },
        italic: {
          fontStyle: 'italic',
        },
        inlineCode: {
          fontFamily: 'Menlo',
          fontSize: rpx(12),
          backgroundColor: '#F1F5F9',
          paddingHorizontal: rpx(4),
          borderRadius: rpx(3),
          color: '#E11D48',
        },
      }),
    [rpx],
  );

  return useMemo(
    () =>
      function renderInline(text: string): React.ReactNode[] {
        const parts: React.ReactNode[] = [];
        const re = /(\*\*`.+?`\*\*|\*\*[^*]+\*\*|\*[^*]+\*|`[^`]+`)/g;
        let last = 0;
        let m: RegExpExecArray | null = null;
        let key = 0;

        while ((m = re.exec(text)) !== null) {
          if (m.index > last) {
            parts.push(text.slice(last, m.index));
          }
          const tok = m[0];
          if (tok.startsWith('**`') && tok.endsWith('`**')) {
            parts.push(
              <Text key={key++} style={[s.inlineCode, s.bold]}>
                {tok.slice(3, -3)}
              </Text>,
            );
          } else if (tok.startsWith('**')) {
            parts.push(
              <Text key={key++} style={s.bold}>
                {tok.slice(2, -2)}
              </Text>,
            );
          } else if (tok.startsWith('`')) {
            parts.push(
              <Text key={key++} style={s.inlineCode}>
                {tok.slice(1, -1)}
              </Text>,
            );
          } else if (tok.startsWith('*')) {
            parts.push(
              <Text key={key++} style={s.italic}>
                {tok.slice(1, -1)}
              </Text>,
            );
          }
          last = m.index + m[0].length;
        }
        if (last < text.length) {
          parts.push(text.slice(last));
        }

        return parts;
      },
    [s],
  );
}
